import React from "react";

import { UrlFiltersContext } from "./context";
import { useFilterParser } from "./useFilterParser";

export const UrlFiltersProvider: React.FC = ({ children }) => {
  const selectedFilters = useFilterParser();
  return (
    <UrlFiltersContext.Provider value={selectedFilters}>{children}</UrlFiltersContext.Provider>
  );
};
